import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { STATUS_LABEL, TYPE_LABEL } from "@/lib/constants";
import { ClipboardList, Loader2, ArrowRight, PenLine, Camera, FileCheck2, AlertCircle, Home, Users } from "lucide-react";

const TYPE_ICON = { online: PenLine, catatan: FileCheck2, latihan: Camera, pr: Home, tatap_muka: Users };
const TODO = ["belum", "dikerjakan", "revisi"];

export default function Assignments() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);
  const navigate = useNavigate();

  const load = () => {
    setLoading(true); setErr(false);
    api.get("/assignments").then((r) => setList(r.data)).catch(() => setErr(true)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-teal-600" /></div>;
  if (err) return (
    <div className="max-w-md mx-auto text-center py-20 space-y-4" data-testid="assignments-error">
      <p className="text-slate-500">Gagal memuat tugas. Coba lagi ya.</p>
      <button onClick={load} className="h-11 px-6 rounded-xl bg-teal-600 hover:bg-teal-700 text-white font-semibold transition-colors" data-testid="assignments-retry-btn">Coba Lagi</button>
    </div>
  );

  const todo = list.filter((a) => TODO.includes(a.my_status || "belum") && a.type !== "tatap_muka");
  const done = list.filter((a) => !(TODO.includes(a.my_status || "belum") && a.type !== "tatap_muka"));
  const ordered = [...todo, ...done];

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-800">Tugasku</h1>
          <p className="text-slate-500 mt-1">Kerjakan tugas online atau unggah foto catatan & latihanmu.</p>
        </div>
        {todo.length > 0 && (
          <span className="inline-flex items-center gap-2 bg-rose-50 text-rose-700 border border-rose-200 rounded-full px-4 py-2 text-sm font-semibold animate-pulse" data-testid="todo-count-banner">
            <AlertCircle className="w-4 h-4" /> {todo.length} tugas belum dikerjakan
          </span>
        )}
      </div>

      {list.length === 0 ? (
        <div className="text-center py-20 text-slate-400"><ClipboardList className="w-12 h-12 mx-auto mb-3 opacity-40" /><p>Belum ada tugas untuk kelasmu.</p></div>
      ) : (
        <div className="space-y-3 stagger">
          {ordered.map((a) => {
            const st = STATUS_LABEL[a.my_status] || STATUS_LABEL.belum;
            const Icon = TYPE_ICON[a.type] || ClipboardList;
            const isTodo = TODO.includes(a.my_status || "belum");
            return (
              <button key={a.id} onClick={() => navigate(`/murid/tugas/${a.id}`)} data-testid={`assignment-item-${a.id}`}
                className={`relative w-full bg-white rounded-2xl p-5 border shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all flex items-center gap-4 text-left ${isTodo ? "border-rose-200 ring-1 ring-rose-100" : "border-slate-100"}`}>
                {isTodo && <span className="absolute top-3 right-3 w-3 h-3 rounded-full bg-rose-500 animate-pulse" data-testid={`todo-dot-${a.id}`} />}
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${isTodo ? "bg-rose-50 text-rose-600" : "bg-teal-50 text-teal-700"}`}><Icon className="w-6 h-6" /></div>
                <div className="flex-1 min-w-0">
                  <p className="font-display font-semibold text-slate-800 truncate">{a.title}</p>
                  <p className="text-xs text-slate-500">{a.subject_name} · {TYPE_LABEL[a.type]}{a.due_date ? ` · Tenggat ${a.due_date.slice(0, 10)}` : ""}</p>
                  <span className={`inline-flex items-center gap-1 mt-2 text-[11px] px-2 py-0.5 rounded-full border ${st.cls}`}>
                    {isTodo && <AlertCircle className="w-3 h-3" />}{st.label}{a.my_final_score != null ? ` · Nilai ${a.my_final_score}` : ""}
                  </span>
                </div>
                <ArrowRight className="w-5 h-5 text-slate-300 shrink-0" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
